module.exports = __webpack_public_path__ + "img/rimg2.4466723a.png";